import { EventBusTopic } from "./event-bus-topics";
export const OosModalTemplate = {
    COVEX: "covEx",
    ESG_VIEW: "esgView",
    GENERIC: "generic",
    RESEARCH_ASSISTANT: "researchAssistant",
    MONITORING: "monitoring",
    STRUCTURED_FINANCE: "structuredFinance",
};
export var FeedbackAvoModuleName;
(function (FeedbackAvoModuleName) {
    FeedbackAvoModuleName["AccountMenu"] = "account menu";
    FeedbackAvoModuleName["Footer"] = "footer";
    FeedbackAvoModuleName["Labs"] = "labs";
})(FeedbackAvoModuleName || (FeedbackAvoModuleName = {}));
//# sourceMappingURL=event-bus.types.js.map